import { HttpUtils } from 'gmrfid-api-core'
import RequestImpl from './utils/requestImpl';

export default {
  init() {
    HttpUtils.setFactory(() => new RequestImpl());
  },
};
